<!-- ─── timesheet-report-viewer.component.html ─────────────────────────── -->

<div class="report-shell" *ngIf="data; else loading">

  <!-- Toolbar -->
  <div class="toolbar no-print">
    <span class="toolbar-title">Employee Monthly Timesheet Report</span>

    <div class="toolbar-actions">
      <button class="btn btn-print" (click)="print()">🖨 Print</button>
      <button class="btn btn-pdf" (click)="downloadPdf()">⬇ Download PDF</button>
    </div>
  </div>

  <!-- Pages -->
  <div class="pages-wrapper" id="report-pages">

    <div class="page" *ngFor="let page of pages; let i = index">

      <!-- ================= HEADER ================= -->
      <div class="page-header">

        <!-- LEFT -->
        <div class="header-left">
          <div><strong>Month:</strong> {{ data.monthName }} {{ data.year }}</div>
          <div><strong>From:</strong> {{ data.periodFrom | date:'dd/MM/yyyy' }}</div>
          <div><strong>To:</strong> {{ data.periodTo | date:'dd/MM/yyyy' }}</div>
        </div>

        <!-- CENTER -->
        <div class="header-center">
          <h2>{{ companyName }}</h2>
          <h3>Employee Monthly Timesheet Report</h3>
        </div>

        <!-- RIGHT -->
        <div class="header-right">
          <img
            *ngIf="companyLogo"
            [src]="companyLogo | imageUrl"
            class="company-logo" />
          <div *ngIf="!companyLogo" class="logo-placeholder">LOGO</div>
        </div>

      </div>

      <!-- ================= LEGEND ================= -->
      <div class="legend-row" *ngIf="i === 0">
        <span class="legend-label">Legend:</span>
        <span class="chip status-wkd">WKD</span>
        <span class="chip status-abs">ABS</span>
        <span class="chip status-exc">EXC</span>
        <span class="chip status-chk">CHK</span>
        <span class="chip status-skl">SKL</span>
        <span class="chip status-lv">LV</span>
        <span class="chip status-hours">8h</span>
      </div>

      <!-- ================= TABLE ================= -->
      <div class="table-scroll-wrapper">
        <table class="report-table">

          <thead>
            <tr>
              <th class="col-id">ID</th>
              <th class="col-name">Employee Name</th>
              <th
                *ngFor="let dayLabel of dayColumns"
                class="col-day">
                {{ dayLabel }}
              </th>
              <th class="col-total">Hours</th>
              <th class="col-total">Late</th>
              <th class="col-total">OT</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of page">

              <td class="col-id">{{ row.employeeId }}</td>
              <td class="col-name" [title]="row.employeeNameEn">{{ row.employeeNameEn }}</td>

              <td
                *ngFor="let dayLabel of dayColumns"
                class="col-day">
                <span
                  *ngIf="getDayValue(row, dayLabel) as val"
                  class="chip"
                  [ngClass]="getCellClass(val)">
                  {{ val }}
                </span>
              </td>

              <td class="col-total">{{ row.totalWorkHours }}</td>
              <td class="col-total" [class.negative]="row.totalLate < 0">{{ row.totalLate }}</td>
              <td class="col-total" [class.positive]="row.totalOT > 0">{{ row.totalOT }}</td>

            </tr>
          </tbody>

        </table>
      </div>

      <!-- ================= FOOTER ================= -->
      <div class="page-footer">
        <span>{{ today }}</span>
        <span>{{ i + 1 }} of {{ pages.length }}</span>
      </div>

    </div>

  </div>

</div>

<!-- Loading -->
<ng-template #loading>
  <div class="loading-state">Loading report…</div>
</ng-template>